








import Stepper from '@/components/Stepper'
import { PalletPattern, IStep } from '@/model/index'
import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { Pages } from '../../pages'

@Component({
  components: {
    Stepper: Stepper
  },
  computed: {
    ...mapGetters('palletpatterns', [
      'isLoading',
      'isLoaded',
      'selectedEntity',
      'steps',
      'isNew'
    ]),
    ...mapGetters('environment', ['isLicenseValid'])
  }
})
export default class CreatePalletPattern extends Vue {
  private homeRouteLink: any = Pages.HOME.routeLink
  private viewRouteLink: any = Pages.VIEWPALLETPATTERNS.routeLink
  private isLoading!: boolean
  private isLoaded!: boolean
  private selectedEntity!: PalletPattern
  private steps!: IStep
  private isNew!: boolean
  private isLicenseValid!: boolean

  private created () {
    this.$store.commit('palletpatterns/SET_NEW', true)
  }

  private localText(arg: string): string {
    return String(this.$t(arg))
  }

  private beforeMount () {
    if (!this.isLicenseValid) {
          this.$router.push({name: Pages.LICENSE.routeName, params: { userActionThatRequiresLicense: this.localText('listButtons.newPal')} })
    }
  }

  private validateStep (value: number) {
    this.$store.dispatch('palletpatterns/validateById', value)
  }

  private async save (palletPattern: PalletPattern, step: number) {
    if (this.isNew) {
      // console.log('save "new" from create.vue', palletPattern)
      await this.$store.dispatch('palletpatterns/addPalletPattern', palletPattern)
      await this.$router.push('/edit-pallet-pattern/' + this.selectedEntity.guid)
      await this.$store.dispatch('palletpatterns/setStep', 2)
      return
    }
    // console.log('update "created" from create.vue')
    const payload = {
      guid: this.selectedEntity.guid,
      palletPattern: palletPattern
    }
    await this.$store.dispatch('palletpatterns/updatePalletPattern', payload)
  }

  private route () {
    this.$router.push(this.homeRouteLink)
  }

  private finish () {
    const guid = this.selectedEntity.guid
    console.log('[DEBUG] data.guid', guid)
    this.$router.push(this.viewRouteLink)
  }
}
